import { useState } from 'react'
import { Minus, Plus } from 'lucide-react'

type Props = {
  value: number
  onChange: (next: number) => void
  max: number
  ariaName: string
}

export default function QuantityStepper({ value, onChange, max, ariaName }: Props) {
  const [bump, setBump] = useState(false)

  const decrement = () => {
    if (value <= 0) return
    onChange(value - 1)
  }

  const increment = () => {
    if (value >= max) {
      setBump(true)
      window.setTimeout(() => setBump(false), 180)
      return
    }
    onChange(value + 1)
  }

  return (
    <div
      data-bump={bump || undefined}
      className="inline-flex items-center rounded-full border border-zinc-950/10 bg-background data-bump:[animation:cartpulse_180ms_ease-out]"
    >
      <button
        type="button"
        onClick={decrement}
        aria-label={`Decrease quantity of ${ariaName}`}
        aria-disabled={value <= 0}
        disabled={value <= 0}
        className="flex size-8 items-center justify-center rounded-l-full text-foreground hover:bg-zinc-950/5 disabled:cursor-not-allowed disabled:text-zinc-400 disabled:hover:bg-transparent"
      >
        <Minus className="size-3.5" />
      </button>
      <span
        aria-live="polite"
        className="min-w-6 px-1 text-center text-sm font-medium tabular-nums"
      >
        {value}
      </span>
      <button
        type="button"
        onClick={increment}
        aria-label={`Increase quantity of ${ariaName}`}
        aria-disabled={value >= max}
        className="flex size-8 items-center justify-center rounded-r-full text-foreground hover:bg-zinc-950/5"
      >
        <Plus className="size-3.5" />
      </button>
    </div>
  )
}
